import { jobApplyWithSonicApplyButtonClickedEvent } from '@lib/analytics-events/job'
import { useJobStore } from '@stores/job.store'
import { useCallback, useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useSearchStore } from '@stores/search.store'
import { JobItem } from '@types'
import { match } from 'ts-pattern'
import useLocale from '@hooks/client/useLocale'

const SONICJOBS_PARTNER_CODE = 'sjw'

export default function useApplyWithSonicApply(): () => void {
  const [sp, setSp] = useState<string>('')
  const [job] = useJobStore(useShallow((state) => [state.job]))
  const [search] = useSearchStore(useShallow((state) => [state.search, state.serpPositionClicked]))
  const locale = useLocale()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search)
      setSp(urlParams.toString())
    }
  }, [])

  const baseUrl = match(process.env.NEXT_PUBLIC_ENVIRONMENT || 'local')
    .with('production', () => 'apply.sonicjobs.com')
    .with('local', () => 'easy-apply-micro.sonic-local.com')
    .with('feature', () => {
      const url = 'easy-apply-micro-%PATH%.sonic-dev.net'
      const match = process.env.NEXT_PUBLIC_BASE_PATH!.match(/(\d+)/)
      const code = match ? match[0] : 'main'

      return url.replace('%PATH%', code)
    })
    .with('staging', () => 'easy-apply-micro-main.sonic-dev.net')
    .otherwise(() => 'easy-apply-micro-main.sonic-dev.net')

  return useCallback(() => {
    jobApplyWithSonicApplyButtonClickedEvent(job as unknown as JobItem, search)
    if (job) {
      const sonicApplyJobUrl = `https://${baseUrl}/${locale}/${SONICJOBS_PARTNER_CODE}/${job.id}?${sp}`
      window.open(sonicApplyJobUrl, '_blank')
    }
  }, [job, search, baseUrl, locale, sp])
}
